var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiHospitalReportIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiHospitalReportIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 3.5h-3v-3C8.5.2 8.3 0 8 0H4c-.3 0-.5.2-.5.5v3h-3c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5h3v3c0 .3.2.5.5.5h4c.3 0 .5-.2.5-.5v-3h3c.3 0 .5-.2.5-.5V4c0-.3-.2-.5-.5-.5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiHospitalReportIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiHospitalReportIcon;